'use es6';

export const PageActionTypes = {
  ABTEST: 'ABTEST',
  ARCHIVE: 'ARCHIVE',
  ATTACH_TO_LANGUAGE_MASTER: 'ATTACH_TO_LANGUAGE_MASTER',
  CHANGE_AUDIENCE_ACCESS: 'CHANGE_AUDIENCE_ACCESS',
  CLONE: 'CLONE',
  CONVERT: 'CONVERT',
  DELETE: 'DELETE',
  EDIT: 'EDIT',
  PROMOTE: 'PROMOTE',
  PROMOTE_AD_CAMPAIGN: 'PROMOTE_AD_CAMPAIGN',
  PROMOTE_SOCIAL_POST: 'PROMOTE_SOCIAL_POST',
  PUBLISH: 'PUBLISH',
  PUBLISHING_OPTIONS: 'PUBLISHING_OPTIONS',
  REMOVE_FROM_LANGUAGE_GROUP: 'REMOVE_FROM_LANGUAGE_GROUP',
  RUN_A_TEST: 'RUN_A_TEST',
  SHARE: 'SHARE',
  SWITCH_LANGUAGE_MASTER: 'SWITCH_LANGUAGE_MASTER',
  TRANSLATE: 'TRANSLATE',
  TRANSLATE_BLOG_POST: 'TRANSLATE_BLOG_POST',
  UNARCHIVE: 'UNARCHIVE',
  UNPUBLISH: 'UNPUBLISH',
  UNPUBLISHING_OPTIONS: 'UNPUBLISHING_OPTIONS',
  USE_IN_LIST: 'USE_IN_LIST',
  VIEW: 'VIEW'
};